<template lang="pug">
  .main
    .header
      slot(name='header')
    .content
      slot(name='content')
    .actions
      slot(name='actions')

</template>

<script>
export default {};
</script>

<style scoped lang="scss">
.main {
  display: flex;
  flex-direction: column;
  border-radius: 0 0 2px 2px;
}

.header {
  flex: 0 0 auto;
  background: #eee;
  padding: 10px;
  display: flex;
  align-items: center;
  border: 1px solid #ddd;
  border-radius: 2px 2px 0 0;
}

.content {
  background: white;
  padding: 15px;
  border: 1px solid #ddd;
  border-top: 0;
  border-radius: 0 0 2px 2px;

  :global(.el-form-item) {
    margin-bottom: 5px;
  }
}

.actions {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 10px;

  :global(.el-button) {
    width: 100%;
    margin-left: 0;
    margin-bottom: 5px;
  }
}
</style>
